<template>
    <div id='preisbewertung' class="preisbewertung">
        <loading :active.sync="isLoading" 
                :can-cancel="false" 
                :is-full-page="fullPage">
        </loading>
        <h5> Preisbewertung </h5> 
        <div class="row">
            <div class="col s12">
                <div class="row">
                    <div class="col s12 m6 l3">
                        <div class="input-field">
                            <label class="active" for="hersteller">Hersteller</label>
                            <input
                                id="hersteller"
                                v-model="manufacturer"
                                v-on:keyup.enter='searchBtnTapped'
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                                @focus="isManufacturerListShown = true, isTypeListShown = false"
                            />
                        </div>

                        <ul v-if="manufacturer && filteredAllManufacturers && isManufacturerListShown">
                            <li v-for="manufacturer in filteredAllManufacturers" :key="manufacturer" @click="setManufacturer(manufacturer)">{{manufacturer}}</li>
                        </ul>
                    </div>

                    <div class="col s12 m6 l3">
                        <div class="input-field">
                            <label class="active" for="typ">Typ 
                                <i v-if="isTypeListLoading" class="fa fa-spinner fa-spin"></i>
                            </label>
                            <input 
                                id="typ"
                                v-model="type"
                                v-on:keyup.enter='searchBtnTapped'
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                                @focus="isTypeListShown = true, isManufacturerListShown = false"
                            />
                        </div>

                        <ul v-if="type && filterAllTypes && isTypeListShown">
                            <li v-for="type in filteredAllTypes" :key="type" @click="setType(type)">{{type}}</li>
                        </ul>
                    </div>

                    <div class="col s12 m6 l3">
                        <div class="input-field">
                            <label class="active" for="tragkraft">Tragkraft</label>
                            <input 
                                id="tragkraft"
                                v-model="loadCapacity"
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                                @focus="isTypeListShown = false, isManufacturerListShown = false"
                            />
                        </div>
                    </div>

                    <div class="col s12 m6 l3">
                        <div class="input-field">
                            <label class="active" for="baujahr">Baujahr</label>
                            <input 
                                id="baujahr"
                                v-model="constructionYear"
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                            />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col s12 m6 l3">
                        <div class="input-field">
                            <label class="active" for="betriebsstunden">Betriebsstunden</label>
                            <input 
                                id="betriebsstunden"
                                v-model="operatingHours"
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                            />
                        </div>
                    </div>

                    <div class="col s12 m6 l3">
                        <div class="input-field">
                            <label class="active" for="hubhöhe">Hubhöhe</label>
                            <input 
                                id="hubhöhe"
                                v-model="liftingHeight"
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                            />
                        </div>
                    </div>

                    <div class="col s12 m6 l3">
                        <div class="input-field">
                            <label class="active" for="mast">Mast</label>
                            <input 
                                id="mast"
                                v-model="mast"
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                            />
                        </div>
                    </div>

                    <div class="col s12 m6 l3">
                        <div class="input-field">
                            <label class="active" for="antriebsart">Antriebsart</label>
                            <input 
                                id="antriebsart"
                                v-model="driveType"
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                            />
                        </div>
                    </div>                    
                </div>

                <div class="row">
                    <div class="col s12 m6 l3">
                        <div class="input-field">
                            <label class="active" for="bauart">Bauart</label>
                            <input 
                                id="bauart"
                                v-model="classificationX"
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                            />
                        </div>
                    </div>

                    <div class="col s12 m6 l3">
                        <div class="input-field">
                            <label class="active" for="bauhöheinmeter">Bauhöhe</label>
                            <input 
                                id="bauhöheinmeter"
                                v-model="closedHeight"
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                            />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col s12 m6 l2">
                        <div class="input-field selectInput">
                            <label class="active" for="zustand">Zustand</label>
                            <select id="zustand" class="browser-default" 
                                v-model="condition" 
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                                >

                                <option value=0>0</option>
                                <option value=1>1</option>
                                <option value=2>2</option>
                                <option value=3>3</option>
                                <option value=4>4</option>
                                <option value=5>5</option>
                                <option value=6>6</option>
                            </select>
                        </div>
                    </div>

                    <div class="col s12 m6 l2">
                        <div class="input-field selectInput">
                            <label class="active" for="seitenschieber">Seitenschieber</label>
                            <select id="seitenschieber" class="browser-default"
                                v-model="hasSideshift" 
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                            >

                                <option value=1>Ja</option>
                                <option value=0>Nein</option>
                            </select>
                        </div>
                    </div>

                    <div class="col s12 m6 l2">
                        <div class="input-field selectInput">
                            <label class="active" for="freihub">Freihub</label>
                             <select id="freihub" class="browser-default"
                                v-model="hasFreeHeight" 
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                            >

                                <option value=1>Ja</option>
                                <option value=0>Nein</option>
                            </select>
                        </div>
                    </div>

                    <div class="col s12 m6 l2">
                        <div class="input-field selectInput">
                            <label class="active" for="ladeSicherungsGitter">LadeSicherungsGitter</label>
                             <select id="ladeSicherungsGitter" class="browser-default"
                                    v-model="hasLoadGuardGrill" 
                                    :disabled='!isSearchBtnShown'
                                    autocomplete="off"
                                >

                                <option value=1>Ja</option>
                                <option value=0>Nein</option>
                            </select>
                        </div>
                    </div>

                    <div class="col s12 m6 l2">
                        <div class="input-field selectInput">
                            <label class="active" for="doppelpalettengabel">Doppelpalettengabel</label>
                             <select id="doppelpalettengabel" class="browser-default"
                                v-model="hasDoublePalletFork" 
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                            >

                                <option value=1>Ja</option>
                                <option value=0>Nein</option>
                            </select>
                        </div>
                    </div>

                    <div class="col s12 m6 l2">
                        <div class="input-field selectInput">
                            <label class="active" for="gabelzinkenverstellgeraet">Gabelzinkenverstellgeraet</label>
                             <select id="gabelzinkenverstellgeraet" class="browser-default"
                                v-model="hasForkPositioner" 
                                :disabled='!isSearchBtnShown'
                                autocomplete="off"
                            >

                                <option value=1>Ja</option>
                                <option value=0>Nein</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col s12 m12 l12">
                        <a v-scroll-to="'#resultDiv'" class="btn blue-grey darken-2" 
                            @click='searchBtnTapped' :disabled='!isSearchBtnShown'>Suche</a>
                    </div>
                </div>
            </div>
        </div>
        <div id="resultDiv" class="row resultDiv" v-if="isResultShown">
            <h5> Ergebnis </h5>

            <!-- Price Rating -->
            <!--
            <div class="row" style="margin: 0px;">
                <div class="col s2">
                    <img class="responsive-img" src="../assets/super_de.png">
                </div>
                <div class="col s2">
                    <img class="responsive-img" src="../assets/good_de.png">
                </div>
                <div class="col s2">
                    <img class="responsive-img" src="../assets/fair_de.png">
                </div>
                <div class="col s2">
                    <img class="responsive-img" src="../assets/abitPricey_de.png">
                </div>
                <div class="col s2">
                    <img class="responsive-img" src="../assets/high_de.png">
                </div>
            </div>
            <div class="row" style="padding-bottom: 30px">
                <div class="col s2">
                    <span>&euro;</span>{{lower_bound_best}} - <span>&euro;</span>{{upper_bound_best}}
                </div>
                <div class="col s2"><span>&euro;</span>{{lower_bound_good}} - <span>&euro;</span>{{upper_bound_good}}
                </div>
                <div class="col s2"><span>&euro;</span>{{lower_bound_fair}} - <span>&euro;</span>{{upper_bound_fair}}
                </div>
                <div class="col s2"><span>&euro;</span>{{lower_bound_increased}} - <span>&euro;</span>{{upper_bound_increased}}
                </div>
                <div class="col s2"><span>&euro;</span>{{lower_bound_high}} - <span>&euro;</span>{{upper_bound_high}}
                </div>
            </div>
            -->

            <!-- Column Chart -->
            <!--
            <div class="row" style="padding-bottom: 30px">
                <div class="col s10">
                    <GChart 
                        type="ColumnChart"
                        :data="chartData"
                        :options="chartOptions"
                    /> 
                </div>
            </div>
            -->

            <!-- Table -->
            <div class="row" style="margin: 0px;">
                <div class="col s2 offset-s1 superPreis"> 
                    <p class="center-align">Super Preis</p>
                </div>

                <div class="col s2 guterPreis"> 
                    <p class="center-align">Guter Preis</p>
                </div>

                <div class="col s2 fairerPreis"> 
                    <p class="center-align">Fairer Preis</p>
                </div>

                <div class="col s2 erhöhterPreis"> 
                    <p class="center-align">Erhöhter Preis</p>
                </div>

                <div class="col s2 hoherPreis"> 
                    <p class="center-align">Hoher Preis</p>
                </div>
            </div>

            <div class="row">
                <div class="col s1 lower_bound_best left-align offset-s1">{{lower_bound_best}}</div>
                <div class="col s2 center-align lower_bound_good">{{lower_bound_good}}</div>
                <div class="col s2 center-align lower_bound_fair" style="border-right: 3px solid black;">{{lower_bound_fair}}</div>
                <div class="col s2 center-align lower_bound_increased">{{lower_bound_increased}}</div>
                <div class="col s2 center-align lower_bound_high">{{lower_bound_high}}</div>
                <div class="col s1 upper_bound_high right-align">{{upper_bound_high}}</div>
            </div>

            <div class="row">
                <div class="col s10 center-align offset-s1 average_fair_price">{{average_fair_price}} (erwarteter Preis)</div>
            </div>
            
            <!-- BoxPlot-->
            
            <div class="row" style="padding-top: 20px">
                <div class="col s12 m12 l12">
                    <!-- <vue-plotly :data="boxPlotData" :layout="layout" :options="options" style="padding-bottom: 20px"/> -->
                    <a  class="btn blue-grey darken-2" @click='resetTapped'>Neue Eingabe</a>
                </div>
            </div>
            
        </div> 
    </div>
</template>

<script src='https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js'></script>

<script>
import Vue from "vue";
import firebase from "firebase";
import fb from "../components/firebaseInit";
import db from "../DB/vehicle_cascading_properties.json";
// import { GChart } from 'vue-google-charts'
// import VuePlotly from '@statnett/vue-plotly'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
     name: 'preisbewertung',
     data(){
        return {
            db,
            manufacturer: null,
            allManufacturers: [],
            filteredAllManufacturers: [],
            isManufacturerListShown: false,

            type: null,
            allTypes: [],
            filteredAllTypes: [],
            isTypeListShown: false,

            loadCapacity: null,
            constructionYear: null,
            operatingHours: null,
            liftingHeight: null,
            condition: null,
            mast: null,
            driveType: null,

            classificationX: null,
            hasFreeHeight: null,
            hasSideshift: null,
            hasForkPositioner: null,
            hasLoadGuardGrill: null,
            hasDoublePalletFork: null,
            closedHeight: null,

            accessToken: null,
            preisbewertungToggle: null,

            isResultShown: false,

            lower_bound_best: null,
            upper_bound_best: null,

            lower_bound_good: null,
            upper_bound_good: null,

            lower_bound_fair: null,
            upper_bound_fair: null,

            lower_bound_increased: null,
            upper_bound_increased: null,

            lower_bound_high: null,
            upper_bound_high: null,

            average_fair_price: null,

            // Box Plot Data
            boxPlotData: [
                {
                    x: [8999, 9199, 9399, 9600, 9800],
                    type: "box",
                    width: 30,
                    hoverinfo: ['skip', 'y'],                   
                },
                
                {
                    x: [8999],
                    name: "Super Preis",
                    marker: {
                        size: 30
                    },
                    hovertext: ['Super Preis<br>Lower Bound: <br>Upper Bound: '],
                    hoverinfo: 'text' 
                },

                {
                    x: [9150],
                    name: "Guter Preis",
                    marker: {
                        size: 30
                    },
                    hovertext: ['Guter Preis<br>Lower Bound: <br>Upper Bound: '],
                    hoverinfo: 'text' 
                },

                {
                    x: [9399],
                    name: "Fairer Preis",
                    marker: {
                        size: 30
                    },
                    hovertext: ['Fairer Preis<br>Lower Bound: <br>Upper Bound: '],
                    hoverinfo: 'text' 
                },

                {
                    x: [9650],
                    name: "Erhöhter Preis",
                    marker: {
                        size: 30
                    },
                    hovertext: ['Erhöhter Preis<br>Lower Bound: <br>Upper Bound: '],
                    hoverinfo: 'text'
                },

                {
                    x: [9800],
                    name: "Hoher Preis",
                    marker: {
                        size: 30
                    },
                    hovertext: ['Hoher Preis<br>Lower Bound: <br>Upper Bound: '],
                    hoverinfo: 'text'
                }
            ],

            layout: {
                title: "Preis",
                font: {
                  size: 10
                },
                margin: {
                    l: 0,
                    r: 0,
                    b: 0,
                    t: 0,
                    pad: 0
                },
                height: 100,
                dragmode: "select",
                hovermode:'closest',     
            },
            
            options: {
                displayModeBar: false,
                responsive: true
            },

            // Column Chart Data
            chartData:[
                    ['Preis', 'Lower Bound(€)', 'Upper Bound(€)'],
                    ['Super Preis', 8800, 8999],
                    ['Guter Preis', 9000, 9199],
                    ['Fairer Preis', 9200, 9399],
                    ['Erhöhter Preis', 9400, 9600],
                    ['Hoher Preis', 9601, 9800]
                ],
            chartOptions: {
               colors: ['#1b9e77', '#d95f02', '#7570b3']
            },

            isSearchBtnShown: true,
            isLoading: false,
            fullPage: true,

            isTypeListLoading: false
        }
     },

     created(){
        // Check if the user has permission to access this module
        const currentUserUID = firebase.auth().currentUser.uid
        const currentUserDoc = fb.collection("user").doc(currentUserUID);
        currentUserDoc.get().then((doc) =>  {
            if (doc.exists) {
                this.preisbewertungToggle = doc.data().preisbewertung
                if (this.preisbewertungToggle == false) {
                    this.$router.replace("/user");
                }
        } else {
            alert("No such document!");
        }        
        }).catch(function(error) {
            alert("Error getting document:", error);
        });

        // Load manufacturers list
        var functions = firebase.app().functions();
        var preisbewertungAPI = functions.httpsCallable('preisbewertung');
        this.isLoading = true
        preisbewertungAPI({}).then((result) => {
            let offersData = (result.data)

            for(let item in offersData){
                if(offersData[item].manufacturerX == null){} else {
                    this.allManufacturers.push(offersData[item].manufacturerX)
                }
            }
            this.allManufacturers = this.allManufacturers.sort()
            this.isLoading = false
        }).catch((err) => {
            this.isLoading = false
            alert(err)
        });        

        // API call
        let url = "https://europe-west1-fmp20-260516.cloudfunctions.net/priceevaluation20"
        let paramsValues = {
            manufacturerX : 'Still',
            typeX : 'RX20-15'
        }
        Vue.axios.get(url, {params: paramsValues})
        .then(response => {
            var bodyJSON = JSON.parse(response.data.body);
        })
        .catch(function (error) {
            alert(error);
        })
     },

     mounted(){
        // for (let i = 0; i < this.db.length; i++) {
        //     this.allManufacturers.push(this.db[i].hersteller);
        // }
        // this.allManufacturers = [...new Set(this.allManufacturers)];

        var elems = document.querySelectorAll('select');
        var instances = M.FormSelect.init(elems, {});
     },

     methods:{
        searchBtnTapped(){
            if(this.manufacturer == null || this.type == null || this.manufacturer == '' || this.type == '' ||
                this.constructionYear == null || this.constructionYear == '' ||
                this.operatingHours == null || this.operatingHours == ''){
                alert('Please select Hersteller, Typ, Baujahr & Betriebsstunden')
                return
            }
            this.isManufacturerListShown = false
            this.isTypeListShown = false

            this.isLoading = true
            this.isResultShown = true
            let url = "https://europe-west1-fmp20-260516.cloudfunctions.net/priceevaluation20"

            let manufacturerPayload = this.manufacturer//this.manufacturer.charAt(0).toUpperCase() + this.manufacturer.slice(1).toLowerCase();
            let typePayload = this.type//this.type.toUpperCase().replace(/\s+/g, '')

            let paramsValues = {
                manufacturerX : manufacturerPayload,
                typeX : typePayload
            }

            if(this.loadCapacity) paramsValues.capacity = this.loadCapacity
            if(this.constructionYear) paramsValues.yearOfManufacture = this.constructionYear
            if(this.operatingHours) paramsValues.operatingHours = this.operatingHours
            if(this.liftingHeight) paramsValues.liftHeight = this.liftingHeight
            if(this.condition) paramsValues.conditionX = this.condition
            if(this.mast) paramsValues.mastTypeX = this.mast
            if(this.driveType) paramsValues.engineTypeX = this.driveType
            if(this.hasFreeHeight) paramsValues.hasFreeHeight = this.hasFreeHeight
            if(this.hasSideshift) paramsValues.hasSideshift = this.hasSideshift
            if(this.hasForkPositioner) paramsValues.hasForkPositioner = this.hasForkPositioner
            if(this.classificationX) paramsValues.classificationX = this.classificationX
            if(this.hasLoadGuardGrill) paramsValues.hasLoadGuardGrill = this.hasLoadGuardGrill
            if(this.hasDoublePalletFork) paramsValues.hasDoublePalletFork = this.hasDoublePalletFork
            if(this.closedHeight) paramsValues.closedHeight = this.closedHeight

            Vue.axios.get(url, {
                params: paramsValues
            })
            .then(response => {
                var bodyJSON = JSON.parse(response.data.body);

                if(bodyJSON == 'no variation in data'){
                    alert('No variation in data.')
                    this.isLoading = false
                    window.location.reload();
                    return
                }

                if(bodyJSON == 'too low population'){
                    alert('Too low population. Please try again.')
                    this.isLoading = false
                    window.location.reload();
                    return
                }

                this.lower_bound_best = bodyJSON.lower_bound_best.toLocaleString('de-DE')
                this.upper_bound_best = bodyJSON.upper_bound_best.toLocaleString('de-DE')

                this.lower_bound_good = bodyJSON.lower_bound_good.toLocaleString('de-DE')
                this.upper_bound_good = bodyJSON.upper_bound_good.toLocaleString('de-DE')

                this.lower_bound_fair = bodyJSON.lower_bound_fair.toLocaleString('de-DE')
                this.upper_bound_fair = bodyJSON.upper_bound_fair.toLocaleString('de-DE')

                this.lower_bound_increased = bodyJSON.lower_bound_increased.toLocaleString('de-DE')
                this.upper_bound_increased = bodyJSON.upper_bound_increased.toLocaleString('de-DE')

                this.lower_bound_high = bodyJSON.lower_bound_high.toLocaleString('de-DE')
                this.upper_bound_high = bodyJSON.upper_bound_high.toLocaleString('de-DE')

                this.average_fair_price = (bodyJSON.lower_bound_fair + bodyJSON.lower_bound_increased) / 2
                this.average_fair_price = this.average_fair_price.toLocaleString('de-DE')

                // this.chartData = [
                //     ['Preis', 'Lower Bound(€)', 'Upper Bound(€)'],
                //     ['Super Preis', this.lower_bound_best, this.upper_bound_best],
                //     ['Guter Preis', this.lower_bound_good, this.upper_bound_good],
                //     ['Fairer Preis', this.lower_bound_fair, this.upper_bound_fair],
                //     ['Erhöhter Preis', this.lower_bound_increased, this.upper_bound_increased],
                //     ['Hoher Preis', this.lower_bound_high, this.upper_bound_high]
                // ]

                // this.boxPlotData = [
                //     {
                //         x: [this.lower_bound_best, this.lower_bound_good, this.lower_bound_fair, this.lower_bound_increased, this.lower_bound_high],
                //         type: "box",
                //         width: 30,
                //         hoverinfo: ['skip', 'y'],                   
                //     },
                    
                //     {
                //         x: [this.lower_bound_best],
                //         name: "Super Preis",
                //         marker: {
                //             size: 30
                //         },
                //         hovertext: ['Super Preis<br>' + 'Lower Bound(€): ' + this.lower_bound_best + '<br>Upper Bound(€): ' + this.upper_bound_best],
                //         hoverinfo: 'text' 
                //     },

                //     {
                //         x: [this.lower_bound_good - 50],
                //         name: "Guter Preis",
                //         marker: {
                //             size: 30
                //         },
                //         hovertext: ['Guter Preis<br>' + 'Lower Bound(€): ' + this.lower_bound_good + '<br>Upper Bound(€): ' + this.upper_bound_good],
                //         hoverinfo: 'text' 
                //     },

                //     {
                //         x: [this.lower_bound_fair],
                //         name: "Fairer Preis",
                //         marker: {
                //             size: 30
                //         },
                //         hovertext: ['Fairer Preis<br>' + 'Lower Bound(€): ' + this.lower_bound_fair + '<br>Upper Bound(€): ' + this.upper_bound_fair],
                //         hoverinfo: 'text' 
                //     },

                //     {
                //         x: [this.lower_bound_increased + 50],
                //         name: "Erhöhter Preis",
                //         marker: {
                //             size: 30
                //         },
                //         hovertext: ['Erhöhter Preis<br>' + 'Lower Bound(€): ' + this.lower_bound_increased + '<br>Upper Bound(€): ' + this.upper_bound_increased],
                //         hoverinfo: 'text'
                //     },

                //     {
                //         x: [this.lower_bound_high],
                //         name: "Hoher Preis",
                //         marker: {
                //             size: 30
                //         },
                //         hovertext: ['Hoher Preis<br>' + 'Lower Bound(€): ' + this.lower_bound_high + '<br>Upper Bound(€): ' + this.upper_bound_high],
                //         hoverinfo: 'text'
                //     }
                // ]
                this.isSearchBtnShown = false
                this.isLoading = false
            })
            .catch(function (error) {
                this.isLoading = false
                alert(error);
            })
        },

        resetTapped(){
            window.location.reload();
        },

        filterAllManufacturers(){
            this.filteredAllManufacturers = this.allManufacturers.filter(manu => {
                return manu.toLowerCase().startsWith(this.manufacturer.toLowerCase())
            })
        },

        setManufacturer(manufacturer){
            this.manufacturer = manufacturer
            this.isManufacturerListShown = false
        },

        filterAllTypes(){
            this.filteredAllTypes = this.allTypes.filter(type => {
                return type.toLowerCase().startsWith(this.type.toLowerCase())
            })
        },

        setType(type){
            this.type = type
            this.isTypeListShown = false
        },

        manufacturerListSow(){
           this.isManufacturerListShown = false
        }
     },

    components:{
        // GChart,
        // VuePlotly,
        Loading
    },

    watch:{
        manufacturer(){
            this.filterAllManufacturers()

            // this.type = ''
            // this.manufacturer = this.manufacturer.toLowerCase()
            // this.allTypes = []
            // for (let i = 0; i < this.db.length; i++) {
            //     if (this.db[i].hersteller == this.manufacturer) {
            //         this.allTypes.push(this.db[i].typ);
            //     }
            // }
            // this.allTypes = [...new Set(this.allTypes)];

            this.type = ''
            this.allTypes = []
            let manufacturerPayload = this.manufacturer.charAt(0).toUpperCase() + this.manufacturer.slice(1).toLowerCase();

            var functions = firebase.app().functions();
            var preisbewertungAPI = functions.httpsCallable('preisbewertung');

            this.isTypeListLoading = true

            preisbewertungAPI({
                manufacturer: manufacturerPayload
            }).then((result) => {
                let offersData = (result.data)
                for(let item in offersData){
                    if(offersData[item].typeX == null){} else {
                        this.allTypes.push(offersData[item].typeX)
                    }
                }
                this.allTypes = this.allTypes.sort()
                this.isTypeListLoading = false
            }).catch((err) => {
                this.isTypeListLoading = false
                alert(err)
            }); 
        },

        type(){
            this.filterAllTypes()
        }
    }
}
</script>
   
<style scoped>
    .preisbewertung {
        padding-bottom: 30px; 
    }
    .resultDiv {
        padding: 20px
    }
    h5 {
        padding: 10px 0 20px 10px;
    }
    .active {
        font-weight: bold; 
        color: #313131;
    }
    input {
        border: 1px solid #313131;
        border-radius: 5px;
        margin-top: 10px;
    }
    .browser-default {
        font-size: 16px;
    }
    span {
        font-weight: bold;
    }
    ul {
        text-transform: uppercase;
        border-bottom: 1px solid #a1a1a1;
        border-left: 1px solid #a1a1a1;
        border-right: 1px solid #a1a1a1;
        border-radius: 5px;
        padding: 0 0 0 10px;
        margin-top: -24px;
        overflow-y: auto; 
        max-height: 115px;
    }
    input { 
        text-transform: uppercase;
    }
    .btn {
        width: 100%;
    }
    .selectInput {
        padding-top: 10px;
        width: 100%;
    }
    .lower_bound_best {
        padding: 0px;
    }
    .upper_bound_high {
        padding: 0px;
    }
    .superPreis {
        color: #f0f0f0; 
        background-color: #2a4ca7; 
        height: 100px;
    }
    .guterPreis {
        color: #f0f0f0; 
        background-color: #da2f37; 
        height: 100px;
    }
    .fairerPreis {
        color: #f0f0f0;
        background-color: #378fba; 
        height: 100px;
    }
    .erhöhterPreis {
        color: #f0f0f0;
        background-color: #51772a;  
        height: 100px;
    }
    .hoherPreis {
        color: #f0f0f0; 
        background-color: #de4556; 
        height: 100px
    }
    @media (max-width: 600px) {
        .superPreis p {
            font-size: 11px;
        }
        .guterPreis p {
            font-size: 11px;
        }
        .fairerPreis p { 
            font-size: 11px;
        }
        .erhöhterPreis p {
            font-size: 11px;
        }
        .hoherPreis p {
            font-size: 11px;
        }

        .lower_bound_best {
            font-size: 9px;
        }
        .lower_bound_good { 
            font-size: 9px;
        }
        .lower_bound_fair {
            font-size: 9px;
        }
        .lower_bound_increased { 
            font-size: 9px;
        }
        .lower_bound_high { 
            font-size: 9px; 
        }
        .upper_bound_high {
            font-size: 9px; 
        }
        .average_fair_price {
            font-size: 11px; 
        }
    }
    @media (min-width: 992px) and (max-width: 1200px){
        .active {
            font-size: 11px;
        }
    }
</style>

